// https://www.facebook.com/musicators.hu

export enum EChoirSocialPageProvider {
    FACEBOOK = 1,
    INSTAGRAM = 2,
    TWITTER = 3,
    YOUTUBE = 4,
};

interface IChoirSocialPageValidationResultError {
    isValid: false,
    error: 'shortURL' | 'unknownPage',
    provider?: EChoirSocialPageProvider,

}

interface IChoirSocialPageValidationResult {
    isValid: true,
    error: null,
    provider: EChoirSocialPageProvider,
}

export const choirSocialPages = [
    {
        path: "https://www.facebook.com/",
        basePath: "facebook.com",
        provider: EChoirSocialPageProvider.FACEBOOK,
    },
    {
        path: "https://www.instagram.com/",
        basePath: "instagram.com",
        provider: EChoirSocialPageProvider.INSTAGRAM,
    },
    {
        path: "https://twitter.com/",
        basePath: "twitter.com",
        provider: EChoirSocialPageProvider.TWITTER,
    },
    {
        path: "https://www.youtube.com/",
        basePath: "youtube.com",
        provider: EChoirSocialPageProvider.YOUTUBE,
    }

]

export const validationChoirSocialPage = (url: string): IChoirSocialPageValidationResultError | IChoirSocialPageValidationResult => {
    for (let page of choirSocialPages) {
        if (url.includes(page.path)) {
            return {
                isValid: true,
                provider: page.provider,
                error: null,
            }
        } else if (url.includes(page.basePath)) {
            return {
                isValid: false,
                provider: page.provider,
                error: "shortURL"
            }
        }
    }
    return {
        isValid: false,
        error: "unknownPage",
    }
}
